/** @jsx h */
import { showCount } from '../config';
import Pagination from './Pagination';
import ResultTitle from './ResultTitle';

const TeaserGeneral = ({
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  function handleLoadMoreClick() {
    loadMore();
  }

  return (
    <div className="search-section__result-container">
      {allResultCount && showCount && (
        <div className="search-section__result-header">
          <ResultTitle allResultCount={allResultCount} />
        </div>
      )}

      <div className="list list--raw">
        <ul>
          {list &&
            list.map((result, index) => (
              <li className="list__item" key={index}>
                {result.mark && (
                  <p className="list__labels is-small">
                    <span
                      className="list__label"
                      // eslint-disable-next-line
                        dangerouslySetInnerHTML={{ __html: result.mark }}
                    />
                  </p>
                )}
                <a
                  href={result.url}
                  className="btn btn--icon-animated"
                  {...(result.isExternal
                    ? { target: '_blank', rel: 'noopener' }
                    : '')}
                >
                  <span>{result.title}</span>
                </a>
                {result.subtitle && <p>{result.subtitle}</p>}
                {result.teaser && <p>{result.teaser}</p>}
              </li>
            ))}
        </ul>
      </div>

      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </div>
  );
};

export default TeaserGeneral;
